import { apiRequest } from './api';
import { AdvWithClient, AdvRequest } from '../types/adv';

export const advService = {
  // Get all advertisements
  getAllAdvs: async (): Promise<AdvWithClient[]> => {
    return await apiRequest<AdvWithClient[]>('/adv');
  },

  // Get advertisement by ID
  getAdvById: async (id: number): Promise<AdvWithClient> => {
    return await apiRequest<AdvWithClient>(`/adv/${id}`);
  },

  // Create new advertisement
  createAdv: async (adv: AdvRequest): Promise<AdvWithClient> => {
    return await apiRequest<AdvWithClient>('/adv/create', {
      method: 'POST',
      body: JSON.stringify(adv)
    });
  },

  // Update existing advertisement
  updateAdv: async (id: number, adv: AdvRequest): Promise<AdvWithClient> => {
    return await apiRequest<AdvWithClient>(`/adv/${id}`, {
      method: 'PUT',
      body: JSON.stringify(adv)
    });
  },

  // Delete advertisement
  deleteAdv: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/adv/${id}`, {
      method: 'DELETE'
    });
  },

  // Upload advertisement file
  uploadAdvFile: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    
    // Get token from stored session (same as api.ts)
    const storedSession = localStorage.getItem('userSession');
    if (!storedSession) {
      throw new Error('No authentication session found');
    }
    
    const session = JSON.parse(storedSession);
    if (!session.token) {
      throw new Error('No authentication token found');
    }
    
    // Use direct backend URL in development to bypass proxy issues
    const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '';
    
    const response = await fetch(`${baseUrl}/api/adv/upload`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${session.token}`,
      },
      body: formData
    });

    if (!response.ok) {
      // Handle authentication errors
      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem('userSession');
        window.location.href = '/login';
        throw new Error('Authentication failed. Please log in again.');
      }
      
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to upload file');
    }

    const result = await response.json();
    return result.path;
  }
}; 